import React, { useState, useEffect, useRef } from "react";
import { createHtmlTemplate } from '../TemplateService';
import { sendHtmlEmail } from '../emailapi';
import { 
  FaMapMarkerAlt, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaClock, 
  FaUser, 
  FaComment,
  FaWhatsapp,
  FaPaperPlane,
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaStar,
  FaParking,
  FaWifi,
  FaCoffee,
  FaShieldAlt,
  FaCalendarAlt,
  FaUsers,
  FaBed,
  FaSwimmingPool,
  FaDumbbell,
  FaUtensils
} from "react-icons/fa";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    checkIn: "",
    checkOut: "",
    guests: "2",
    message: ""
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    setTimeout(async () => {
      const generatedHtml = createHtmlTemplate(formData);
      try {
        const result = await sendHtmlEmail(
          "paridhiguest@gmail.com",
          "New Booking Inquiry - Paridhi Guest House",
          generatedHtml
        );
        
        if (result.success) {
          console.log("Email dispatched successfully.");
        }
      } catch (err) {
        console.error("Failed to send inquiry.");
      }

      setIsSubmitting(false);
      setShowSuccess(true);
      
      setFormData({
        fullName: "",
        email: "",
        phone: "",
        checkIn: "",
        checkOut: "",
        guests: "2",
        message: ""
      });
      
      setTimeout(() => setShowSuccess(false), 5000);
    }, 1000);
  };

  const amenities = [
    { icon: FaWifi, name: "Free WiFi", color: "text-blue-500" },
    { icon: FaCoffee, name: "Free Breakfast", color: "text-orange-500" },
    { icon: FaParking, name: "Free Parking", color: "text-green-500" },
    { icon: FaShieldAlt, name: "24/7 Security", color: "text-red-500" },
  ];
  return (
    <section id="contact" ref={sectionRef} className="py-16 px-4 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        
        {/* Section Header */}
        <div className={`text-center mb-12 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <span className="text-blue-600 font-semibold tracking-wider text-sm uppercase bg-blue-100 px-4 py-1.5 rounded-full inline-block mb-3">
            Get In Touch
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
            Contact <span className="text-blue-600">Paridhi Guest House</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Experience luxury and comfort at its best. Book your stay with us today!
          </p>
        </div>
        {/* Contact Cards */}
        <div className={`grid grid-cols-1 md:grid-cols-3 gap-5 mb-10 transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <a 
            href="tel:+095550 40589"
            className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 group hover:-translate-y-1"
          >
            <div className="bg-green-100 p-3 rounded-full group-hover:bg-green-500 transition-colors duration-300">
              <FaPhoneAlt className="text-green-600 group-hover:text-white text-xl" />
            </div>
            <div>
              <p className="text-xs text-gray-500 uppercase tracking-wide">Call Us</p>
              <p className="font-semibold text-gray-800">+91 95550 40589</p>
              <p className="text-xs text-gray-400">24/7 Support</p>
            </div>
          </a>

          <a 
            href="https://wa.me/095550 40589"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 group hover:-translate-y-1"
          >
            <div className="bg-green-100 p-3 rounded-full group-hover:bg-green-500 transition-colors duration-300">
              <FaWhatsapp className="text-green-600 group-hover:text-white text-xl" />
            </div>
            <div>
              <p className="text-xs text-gray-500 uppercase tracking-wide">WhatsApp</p>
              <p className="font-semibold text-gray-800">Chat with us</p>
              <p className="text-xs text-gray-400">Instant Response</p>
            </div>
          </a>

          <a 
            href="mailto:paridhiguest@gmail.com"
            className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 group hover:-translate-y-1"
          >
            <div className="bg-purple-100 p-3 rounded-full group-hover:bg-purple-500 transition-colors duration-300">
              <FaEnvelope className="text-purple-600 group-hover:text-white text-xl" />
            </div>
            <div>
              <p className="text-xs text-gray-500 uppercase tracking-wide">Email Us</p>
              <p className="font-semibold text-gray-800">paridhiguest@gmail.com</p>
              <p className="text-xs text-gray-400">Quick Reply</p>
            </div>
          </a>
        </div>
        
        {/* Main Contact Form Section */}
        <div className={`bg-white rounded-2xl shadow-xl overflow-hidden transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Left Side - Contact Information */}
            <div className="bg-gradient-to-br from-blue-600 to-indigo-700 p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">Paridhi Guest House</h3>
              <p className="text-blue-100 mb-6 leading-relaxed">
                Experience the perfect blend of luxury, comfort, and traditional hospitality. 
                Your home away from home in the heart of the city.
              </p>
              
              <div className="space-y-5">
                <div className="flex gap-3">
                  <FaMapMarkerAlt className="text-xl mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold mb-1">Our Location</p>
                    <p className="text-sm text-blue-100 leading-relaxed">
                      2, Sri Ram Nagar Colony,<br />
                      Near Kailashpuri Seva Aashram,<br />
                      Mahmoorganj, Ranipur Road,<br />
                      Varanasi - 221106, Uttar Pradesh
                    </p>
                  </div>
                </div>
                
                <div className="flex gap-3">
                  <FaClock className="text-xl mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold mb-1">Check-in / Check-out</p>
                    <p className="text-sm text-blue-100">Check-in: 12:00 PM</p>
                    <p className="text-sm text-blue-100">Check-out: 11:00 AM</p>
                    <p className="text-sm text-blue-100 mt-1">24/7 Guest Support Available</p>
                  </div>
                </div>
              </div>

              {/* Amenities Grid */}
              <div className="mt-6 pt-6 border-t border-blue-400/30">
                <p className="font-semibold mb-3">Premium Amenities</p>
                <div className="grid grid-cols-2 gap-2">
                  {amenities.map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm">
                      <item.icon className="text-blue-200 text-xs" />
                      <span className="text-blue-100">{item.name}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="mt-6 pt-6 border-t border-blue-400/30">
                <p className="font-semibold mb-3">Follow Us</p>
                <div className="flex gap-3">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition-all">
                    <FaFacebook className="text-white" />
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition-all">
                    <FaInstagram className="text-white" />
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition-all">
                    <FaTwitter className="text-white" />
                  </a>
                </div>
              </div>
            </div>

            {/* Right Side - Contact Form */}
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Book Your Stay</h3>
              <p className="text-gray-500 mb-6">Fill out the form below and we'll get back to you within 4 hours.</p>
              
              {showSuccess && (
                <div className="mb-5 p-4 bg-green-50 border border-green-200 rounded-lg animate-fade-in">
                  <p className="text-green-700 font-medium">✓ Booking Request Sent Successfully!</p>
                  <p className="text-green-600 text-sm">We'll contact you soon to confirm your reservation.</p>
                </div>
              )}
              
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Full Name *
                    </label>
                    <div className="relative">
                      <FaUser className="absolute left-3 top-3 text-gray-400" />
                      <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                        className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Enter your name"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email *
                    </label>
                    <div className="relative">
                      <FaEnvelope className="absolute left-3 top-3 text-gray-400" />
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Enter your email"
                      />
                    </div>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Phone Number *
                    </label>
                    <div className="relative">
                      <FaPhoneAlt className="absolute left-3 top-3 text-gray-400" />
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="+91 95550 40589"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Number of Guests *
                    </label>
                    <div className="relative">
                      <FaUsers className="absolute left-3 top-3 text-gray-400" />
                      <select
                        name="guests"
                        value={formData.guests}
                        onChange={handleChange}
                        required
                        className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none"
                      >
                        <option value="1">1 Guest</option>
                        <option value="2">2 Guests</option>
                        <option value="3">3 Guests</option>
                        <option value="4">4 Guests</option>
                        <option value="5">5+ Guests</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Check-in Date *
                    </label>
                    <div className="relative">
                      <FaCalendarAlt className="absolute left-3 top-3 text-gray-400" />
                      <input
                        type="date"
                        name="checkIn"
                        value={formData.checkIn}
                        onChange={handleChange}
                        required
                        className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Check-out Date *
                    </label>
                    <div className="relative">
                      <FaCalendarAlt className="absolute left-3 top-3 text-gray-400" />
                      <input
                        type="date"
                        name="checkOut"
                        value={formData.checkOut}
                        onChange={handleChange}
                        required
                        className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Special Requests / Message
                  </label>
                  <div className="relative">
                    <FaComment className="absolute left-3 top-3 text-gray-400" />
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="3"
                      className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                      placeholder="Any special requests or preferences..."
                    ></textarea>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
                >
                  {isSubmitting ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Sending...
                    </>
                  ) : (
                    <>
                      Send Booking Request
                      <FaPaperPlane className="text-sm" />
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Google Map */}
        <div className={`mt-8 rounded-2xl overflow-hidden h-96 shadow-xl transition-all duration-700 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <iframe
            title="Paridhi Guest House Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.123456789012!2d82.973449!3d25.317645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398e2e123456789%3A0x123456789abcdef!2sVaranasi%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full h-full hover:grayscale-0 grayscale transition-all duration-500"
          ></iframe>
        </div>

        {/* Bottom Note */}
        <div className={`text-center mt-8 transition-all duration-700 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <p className="text-sm text-gray-500">
            📍 Conveniently located near Banaras Railway Station | 🚕 Airport transfers available on request
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fadeIn 0.5s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default ContactSection;